// @flow

import SharedColors from 'frontend_core/dist/styles/colors'

export default Object.assign(SharedColors, {})
